<template>
  <v-card class="d-flex flex-column item" :to="to" flat tile>
    <img
      @error="errorImage"
      loading="lazy"
      class="d-block item-img"
      :src="smAndDown ? img : img_small"
      :alt="title"
    />

    <div class="pa-4">
      <v-btn
        v-if="!isTerrain && category"
        class="
          white--text
          text-body-1 text-none
          font-weight-medium
          py-1
          px-2
          item-category
        "
        color="primary"
        :to="parsedCategory.to"
        height="auto"
        min-width="auto"
        depressed
        tile
      >
        {{ parsedCategory.title }}
      </v-btn>

      <div
        v-if="reference"
        class="primary--text text-body-2 font-weight-regular mt-1"
      >
        Ref.: {{ reference }}
      </div>

      <div class="primary--text text-body-1 mt-1">
        <span v-if="district" class="font-weight-medium">
          {{ district }}
        </span>

        <span v-if="district && city" class="font-weight-regular"> | </span>

        <span v-if="city" class="font-weight-regular">
          {{ city + " " + state }}
        </span>
      </div>

      <div
        v-if="price"
        class="primary--text text-subtitle-1 font-weight-regular mt-1"
      >
        {{ formatPrice(price) }}
      </div>
    </div>

    <div class="mt-auto">
      <v-sheet
        class="position-relative"
        :class="[isTerrain ? 'my-4' : 'my-6']"
        color="rgba(214, 208, 209, 0.50)"
        width="100%"
        height="1px"
      >
        <div
          v-if="!isTerrain && business"
          class="
            primary--text
            text-caption text-uppercase
            font-weight-medium
            py-1
            px-3
            item-business
          "
        >
          {{ business }}
        </div>
      </v-sheet>
    </div>

    <v-sheet
      class="d-flex align-center justify-center px-4 pb-4 item-features"
      height="36px"
    >
      <div
        v-for="({ text, icon, size }, keyFeatures) in features"
        :key="keyFeatures"
        class="d-flex align-center"
      >
        <v-icon color="primary" :size="size" left>
          {{ icon }}
        </v-icon>

        <div class="text--primary text-body-2 font-weight-regular">
          {{ text }}
        </div>
      </div>
    </v-sheet>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";
import { formatToURL } from "../../utils/formatToURL";
import { formatPrice } from "../../utils/formatPrice";
import { formatArea } from "../../utils/formatArea";

export default {
  props: {
    img: {
      type: String,
      default: "",
    },
    img_small: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "",
    },
    district: {
      type: String,
      default: "",
    },
    reference: {
      type: String,
      default: "",
    },
    city: {
      type: String,
      default: "",
    },
    state: {
      type: String,
      default: "",
    },
    price: {
      type: Number,
      default: 0,
    },
    business: {
      type: String,
      default: "",
    },
    garage: {
      type: Number,
      default: 0,
    },
    bedrooms: {
      type: Number,
      default: 0,
    },
    area: {
      type: Number,
      default: 0,
    },
    total_area: {
      type: Number,
      default: 0,
    },
    isTerrain: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    path() {
      if (["Área", "Chácara", "Fazenda", "Sítio"].includes(this.category))
        return "/rural";
      else if (["Terreno", "Terreno Comercial"].includes(this.category))
        return "/terrenos";
      else if (this.business === "Venda") return "/imoveis";
      else return "/locacao";
    },
    features() {
      const features = [];

      if (
        ![
          "Área",
          "Chácara",
          "Fazenda",
          "Sítio",
          "Terreno",
          "Terreno Comercial",
        ].includes(this.category) &&
        this.garage
      )
        features.push({
          text: this.garage,
          icon: "fa-car",
          size: 16,
        });

      if (
        ![
          "Área",
          "Chácara",
          "Fazenda",
          "Sítio",
          "Terreno",
          "Terreno Comercial",
        ].includes(this.category) &&
        this.bedrooms
      )
        features.push({
          text: this.bedrooms,
          icon: "fa-bed",
          size: 16,
        });

      if (
        ![
          "Área",
          "Chácara",
          "Fazenda",
          "Sítio",
          "Terreno",
          "Terreno Comercial",
        ].includes(this.category) &&
        this.area
      )
        features.push({
          text: formatArea(this.area),
          icon: "fa-home",
          size: 16,
        });

      if (this.total_area)
        features.push({
          text: formatArea(
            this.total_area *
              (["Área", "Chácara", "Fazenda", "Sítio"].includes(this.category)
                ? 0.0001
                : 1),
            ["Área", "Chácara", "Fazenda", "Sítio"].includes(this.category)
              ? " hectares"
              : "m²"
          ),
          icon: "fa-expand-arrows-alt",
          size: 14,
        });

      return features;
    },
    parsedCategory() {
      return this.category
        ? {
            title: this.category,
            to: `${this.path}?tipo=${this.category}`,
          }
        : "";
    },
    title() {
      if (!this.category || !this.district) return null;

      const category = this.category.split(" ").pop();
      const district = this.district.split(" ");
      let parsedDistrict = this.district;

      if (category == district[0])
        parsedDistrict = parsedDistrict.replace(category, "");

      return this.category + " " + parsedDistrict;
    },
    to() {
      return `${this.path}/${formatToURL(this.title)}-${this.reference}`;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    formatPrice,
    errorImage(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid rgba(214, 208, 209, 0.5);

  &-img {
    aspect-ratio: 880 / 570;
    margin-left: -1px;
    margin-right: -1px;
    margin-top: -1px;
    object-fit: cover;
    position: relative;
    width: 100%;
    width: calc(100% + 2px);
  }

  &-business {
    background-color: white;
    border: 1px solid rgba(214, 208, 209, 0.5);
    left: 50%;
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%);
  }

  &-features {
    gap: 16px;
  }
}
</style>
